import { render, staticRenderFns } from "./SearchComponentForm.vue?vue&type=template&id=ae4b37a6"
import script from "./SearchComponentForm.vue?vue&type=script&lang=js"
export * from "./SearchComponentForm.vue?vue&type=script&lang=js"
import style0 from "./SearchComponentForm.vue?vue&type=style&index=0&id=ae4b37a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports